module.exports = __webpack_public_path__ + "static/img/exploit13.90e72323.png";